export interface CookieCategory {
  id: string;
  name: string;
  description: string;
  essential: boolean;
  enabled: boolean;
}

export interface CookieConsent {
  status: 'pending' | 'configured';
  timestamp: number;
  categories: Record<string, boolean>;
  consentType?: 'accept-all' | 'reject-all' | 'custom';
}

export const COOKIE_CATEGORIES: Record<string, Omit<CookieCategory, 'enabled'>> = {
  necessary: {
    id: 'necessary',
    name: 'Strictly Necessary',
    description: 'These cookies are essential for the website to function properly. They enable core functionality such as security, network management, and accessibility.',
    essential: true,
  },
  analytics: {
    id: 'analytics',
    name: 'Analytics',
    description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
    essential: false,
  },
};